import {combineReducers} from 'redux'
import {combineForms} from 'react-redux-form'
import loginReducer from './login/reducer'
import searchReducer from './search/reducer'
import reportReducer from './report/reducer'
import refreshTokenReducer from './refresh-token/reducer'
import decisionTreeReducer from './decision-tree/reducer'

export default combineReducers({
  login: loginReducer,
  report: reportReducer,
  refreshToken: refreshTokenReducer,
  decisionTree: decisionTreeReducer,
  myForms: combineForms({
    search: searchReducer,
  }, 'myForms'),
})



// WEBPACK FOOTER //
// ./src/store/reducer.js